import React, {Fragment} from "react";
import {isEmpty} from "lodash";
import {Row, Col, FormGroup, Input, ModalFooter, ModalBody} from "reactstrap";
import ZeusButton from "../../../components/Button";
import CustomFieldsList from "../../../components/Forms/CustomFieldsList";
import {messages} from "../../../constants";
import {useFormData} from "./useFormData";

const AddCustomerForm = (props) => {
  const {data, defaultRoute, onCancel} = props;
  const {formData, handleSubmit, handleChange, submitted} = useFormData(data, onCancel);
  const {name = "", custom_fields = []} = formData;

  return (
    <Fragment>
      <ModalBody>
        <Row>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="first_name">
                Name
                <span className="text-red">*</span>
              </label>
              <Input
                className="form-control-alternative"
                placeholder="Enter Customer Name"
                type="text"
                name="name"
                value={name}
                invalid={isEmpty(name) && submitted}
                data-cy="customer_name"
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <CustomFieldsList
          fields={custom_fields}
          onChange={(fields) => {
            handleChange({target: {name: "custom_fields", value: fields}});
          }}
        />
      </ModalBody>
      <ModalFooter
        style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}
      >
        <div>
          {defaultRoute && (
            <div className="custom-control custom-control-alternative custom-checkbox">
              <input
                className="custom-control-input"
                id=" customCheckLogin"
                type="checkbox"
                checked={true}
                disabled
              />
              <label className="custom-control-label" htmlFor=" customCheckLogin">
                <span className="text-muted">{messages.modals.note.setCustomer}</span>
              </label>
            </div>
          )}
        </div>
        <div>
          <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
            SEND
          </ZeusButton>
          <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
            CANCEL
          </ZeusButton>
        </div>
      </ModalFooter>
    </Fragment>
  );
};

export default AddCustomerForm;
